var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('h2',{staticClass:"f-w-700"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title)))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }